export const WALLET_PRODUCT_ERROR_CODE = "WALLET_PRODUCT_ERRORS";
export const WALLET_UPLOAD_ERROR_CODE = "WALLET_UPLOAD_ERROR";

const PRODUCT_ERROR_TEXT = "Hay productos sin línea definida o inexistentes en BD";

export function extractWalletUploadError(err) {
  const data = err?.response?.data ?? null;
  const message =
    data?.message ||
    data?.error ||
    err?.message ||
    "Error al cargar la cartera. Intente de nuevo.";
  return { data, message };
}

function groupDetailsByArchivo(details = []) {
  return (details || []).reduce((acc, d) => {
    const archivo = d.archivo || d.origen || "Detalle";
    if (!acc[archivo]) acc[archivo] = [];
    acc[archivo].push({
      archivo,
      codigo: d.codigo ?? d.numeroRaw ?? "—",
      nombre: d.nombre ?? d.descripcion ?? "—",
      celda: d.celda || d.productCell || "—",
      motivo: d.motivo || d.error || "—"
    });
    return acc;
  }, {});
}

function isProductErrorPayload(data) {
  if (!data) return false;
  if (data.errorCode === WALLET_PRODUCT_ERROR_CODE) return true;
  const err = String(data.error || "").toLowerCase();
  const looksLikeProduct =
    err.includes("producto") ||
    err.includes("línea") ||
    err.includes("linea") ||
    err === PRODUCT_ERROR_TEXT.toLowerCase();
  if (!looksLikeProduct && !data.porArchivo) return false;
  return Boolean(
    data.porArchivo ||
    data.codigos?.length ||
    (Array.isArray(data.details) && data.details.length)
  );
}

/**
 * Normaliza la respuesta 4xx del upload para el modal de errores.
 */
export function normalizeWalletUploadErrorForModal(data) {
  if (!data || typeof data !== "object") return null;

  if (isProductErrorPayload(data)) {
    let porArchivo = data.porArchivo || {};
    if (!Object.keys(porArchivo).length && Array.isArray(data.details) && data.details.length) {
      porArchivo = groupDetailsByArchivo(data.details);
    }
    return {
      ...data,
      modalType: "product",
      porArchivo,
      count: data.count ?? data.details?.length ?? 0
    };
  }

  let porArchivo = data.porArchivo || {};
  if (!Object.keys(porArchivo).length && Array.isArray(data.details) && data.details.length) {
    porArchivo = groupDetailsByArchivo(data.details);
  }

  const hasTable = Object.keys(porArchivo).length > 0;

  return {
    modalType: hasTable ? "details" : "generic",
    error: data.error || "Error al cargar cartera",
    message: data.message || data.error,
    accion: data.accion,
    lineName: data.lineName,
    missing: data.missing,
    pendingWalletCount: data.pendingWalletCount,
    porArchivo,
    count: data.count ?? data.details?.length ?? 0,
    details: data.details
  };
}

export function shouldOpenWalletUploadErrorModal(normalized) {
  return normalized != null;
}
